import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RouteService, Route } from '../../services/routes';
import { RouteSelectionService } from '../../services/route-selection';
import { SearchBarComponent } from '../../components/search-bar.component/search-bar-component';
import { AuthService } from '../../services/auth-service';

@Component({
  selector: 'app-select-route',
  standalone: true,
  templateUrl: './select-route-component.html',
  styleUrls: ['./select-route-component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    FormsModule,
    SearchBarComponent
  ],
})
export class SelectRouteComponent implements OnInit, OnDestroy {
  routes: Route[] = [];
  filteredRoutes: Route[] = [];
  searchTerm: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private routeSelectionService: RouteSelectionService,
    private routeService: RouteService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.authService.getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe(userInfo => {
        if (userInfo) {
          let routeIds = userInfo.routeIds || [];
          let isSalesAdmin = userInfo.isSalesAdmin;

          // Then fetch routes
          this.routeService.get()
            .pipe(takeUntil(this.destroy$))
            .subscribe(routes => {
              this.routes = isSalesAdmin
                ? routes
                : routes.filter(route => routeIds.includes(route.id));
              this.filteredRoutes = [...this.routes];
            });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectRoute(route: Route): void {
    this.routeSelectionService.setSelected(route, true);
    this.searchTerm = ''; // Clear search after selection
    this.router.navigate(['/sales']);
  }

  searchRoutes(): void {
    const term = this.searchTerm.trim().toLowerCase();
    this.filteredRoutes = this.routes.filter(route =>
      route?.route?.toLowerCase().includes(term)
    );
  }
}
